export default __webpack_public_path__ + "static/media/blindBox.62d040d1.mp4";